<div class="d-block d-lg-none">
  <fgb-mobile-page-header
    pageTitle="wallet.claimed.page.banner"
    [showBalance]="false"
    [showQr]="false"
    [showFooter]="true"
    [backButtonLink]="'/rewards/wallet'"
  ></fgb-mobile-page-header>
</div>

<div class="container">
  <!-- Back Button -->
  <div class="page-padding d-lg-block d-none">
    <a class="cursor-pointer wallet-back-button mb-3 bg-glass-dark" [routerLink]="'/rewards/wallet'">
      <span class="icon material-icons text-white">arrow_back_ios</span>
    </a>
  </div>
  <!-- Title -->
  <h5 class="mb-2 text-black wallet-redeemed-title text-capitalize">{{ 'wallet.redeemed.title' | translate }}</h5>
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [pageSize]="0"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="border border-disabled bg-white rounded">
    <div class="font-size-12 text-center text-black py-3">
      {{ 'claimed.rewards.placeholder.description' | translate }}
    </div>
  </div>
</ng-template>
